module.exports = __webpack_public_path__ + "static/img/yq-brief.19f606e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20250724/ruanjian/yq-brief.svg
// module id = 4j/F
// module chunks = 7